'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@morpho-org/ui-v6/utils';
import { Button, Icon } from '@repo/ui';
import { ArrowUp, Close } from '@repo/ui/icons';
import { forwardRef } from 'react';
import type { SortByOption, SortDirection } from './SortBy';
interface SortByTriggerProps<T> {
  selectedOption: SortByOption<T> | undefined;
  direction: SortDirection;
  onClear: () => void;
  onDirectionToggle: () => void;
  clearable: boolean;
  disabled: boolean;
}
function SortByTriggerInner(t0, ref) {
  const $ = _c(28);
  let clearable;
  let direction;
  let disabled;
  let onDirectionToggle;
  let props;
  let selectedOption;
  let t1;
  if ($[0] !== t0) {
    const {
      selectedOption: t2,
      direction: t3,
      onClear,
      onDirectionToggle: t4,
      clearable: t5,
      disabled: t6,
      ...t7
    } = t0;
    selectedOption = t2;
    direction = t3;
    onDirectionToggle = t4;
    clearable = t5;
    disabled = t6;
    props = t7;
    t1 = function handleClearClick(event) {
      event.stopPropagation();
      onClear();
    };
    $[0] = t0;
    $[1] = clearable;
    $[2] = direction;
    $[3] = disabled;
    $[4] = onDirectionToggle;
    $[5] = props;
    $[6] = selectedOption;
    $[7] = t1;
  } else {
    clearable = $[1];
    direction = $[2];
    disabled = $[3];
    onDirectionToggle = $[4];
    props = $[5];
    selectedOption = $[6];
    t1 = $[7];
  }
  const handleClearClick = t1;
  let t2;
  if ($[8] !== onDirectionToggle) {
    t2 = function handleArrowClick(event_0) {
      event_0.stopPropagation();
      onDirectionToggle();
    };
    $[8] = onDirectionToggle;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const handleArrowClick = t2;
  const t3 = selectedOption && clearable ? "pr-[5px]" : "pr-[10px]";
  let t4;
  if ($[10] !== t3) {
    t4 = cn("gap-2xs flex items-center", "py-[3px] pl-[10px]", t3);
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== direction || $[13] !== handleArrowClick || $[14] !== selectedOption) {
    t5 = selectedOption && <span onClick={handleArrowClick} role="button" data-testid="sort-by-direction" className={cn("flex shrink-0 cursor-pointer items-center justify-center", "text-secondary-foreground hover:!text-foreground", direction === "desc" && "rotate-180")}><ArrowUp /></span>;
    $[12] = direction;
    $[13] = handleArrowClick;
    $[14] = selectedOption;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-3xs text-foreground whitespace-nowrap">Sort by</span>;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== clearable || $[18] !== handleClearClick || $[19] !== selectedOption) {
    t7 = selectedOption && <><span className="text-3xs text-foreground truncate">{selectedOption.label}</span>{clearable && <span onClick={handleClearClick} role="button" data-testid="sort-by-clear" className={cn("cursor-pointer border-none bg-transparent p-0", "text-secondary-foreground hover:text-foreground")}><Icon icon={<Close />} /></span>}</>;
    $[17] = clearable;
    $[18] = handleClearClick;
    $[19] = selectedOption;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== disabled || $[22] !== props || $[23] !== ref || $[24] !== t4 || $[25] !== t5 || $[26] !== t7) {
    t8 = <Button variant="ghost" size="sm" disabled={disabled} ref={ref} data-testid="sort-by-trigger" className={t4} {...props}>{t5}{t6}{t7}</Button>;
    $[21] = disabled;
    $[22] = props;
    $[23] = ref;
    $[24] = t4;
    $[25] = t5;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
}

// oxlint-disable-next-line typescript/consistent-type-assertions
export const SortByTrigger = forwardRef(SortByTriggerInner) as <T>(props: SortByTriggerProps<T> & React.RefAttributes<HTMLButtonElement>) => React.ReactElement;